<template>
  <sidebar-item :link="{name: $t('Импорт данных'),  path: `/import`,  icon: 'vip_icon icon_brand'}">
  </sidebar-item>
</template>
<script>
    export default {
        name: 'ImportMenu',
    }
</script>
